import React, { useState, useEffect } from "react";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";

export default function MassagesSender() {

    const [categories, setCategories] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        senderNumber: "",
        category: "",
        platform: "",
        count: "",
        message: ""
    });

    // Fetch categories on component mount
    useEffect(() => {
        fetchCategories();
        setupPlatforms();
    }, []);

    const fetchCategories = async () => {
        try {
            const response = await apiRequests.get('/api/category/v1/get-all-category');
            if (response.data) {
                setCategories(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
            // toast.error("خطا در دریافت دسته بندی ها");
        }
    };

    const setupPlatforms = () => {
        // Social media platforms and messaging apps
        const platformsList = [
            { id: "sms", name: "SMS" },
            { id: "telegram", name: "تلگرام" },
            { id: "whatsapp", name: "واتساپ" },
            { id: "instagram", name: "اینستاگرام" },
            { id: "eitaa", name: "ایتا" },
            { id: "rubika", name: "روبیکا" },
            { id: "soroush", name: "سروش" },
            { id: "bale", name: "بله" },
            { id: "gap", name: "گپ" }
        ];
        setPlatforms(platformsList);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const sendApi = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.senderNumber) {
            toast.error("لطفا شماره ارسال کننده را وارد کنید");
            return;
        }
        if (!formData.category) {
            toast.error("لطفا دسته بندی را انتخاب کنید");
            return;
        }
        if (!formData.platform) {
            toast.error("لطفا پلتفرم ارسال را انتخاب کنید");
            return;
        }
        if (!formData.count || formData.count <= 0) {
            toast.error("لطفا تعداد معتبر وارد کنید");
            return;
        }
        if (!formData.message) {
            toast.error("لطفا متن پیام را وارد کنید");
            return;
        }

        setLoading(true);

        // Prepare data for API
        const apiData = {
            message: formData.message,
            platform: formData.platform,
            count: parseInt(formData.count),
            category: formData.category,
            senderNumber: formData.senderNumber
        };

        try {
            const response = await apiRequests.post('/api/admin/v1/send-message-admin', apiData);
            toast.success("پیام با موفقیت ارسال شد");

            // Reset form after successful submission
            setFormData({
                senderNumber: "",
                category: "",
                platform: "",
                count: "",
                message: ""
            });
        } catch (error) {
            console.error("Error sending message:", error);
            // toast.error("خطا در ارسال پیام. لطفا مجددا تلاش کنید");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="p-20 flex items-center justify-center gap-8">
            <form onSubmit={sendApi} className="grid grid-cols-2 auto-cols-auto gap-x-8 gap-y-2 w-full">
                <div className="flex flex-col gap-1">
                    <span>شماره ارسال کننده</span>
                    <input
                        type="text"
                        name="senderNumber"
                        value={formData.senderNumber}
                        onChange={handleInputChange}
                        className="w-full border border-gray-300 rounded-md p-2 mb-4"
                        placeholder="شماره را وارد کنید"
                        dir="ltr"
                    />
                </div>

                <div className="flex flex-col gap-1">
                    <span>دسته بندی</span>
                    <select
                        name="category"
                        value={formData.category}
                        onChange={handleInputChange}
                        className="w-full border border-gray-300 rounded-md p-2 mb-4"
                    >
                        <option value="">انتخاب دسته بندی</option>
                        {categories.map((category) => (
                            <option key={category.id || category._id} value={category.id || category._id}>
                                {category.Name || ""}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex flex-col gap-1">
                    <span>پلتفرم ارسال</span>
                    <select
                        name="platform"
                        value={formData.platform}
                        onChange={handleInputChange}
                        className="w-full border border-gray-300 rounded-md p-2 mb-4"
                    >
                        <option value="">انتخاب پلتفرم</option>
                        {platforms.map((platform) => (
                            <option key={platform.id} value={platform.id}>
                                {platform.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex flex-col gap-1">
                    <span>تعداد</span>
                    <input
                        type="number"
                        name="count"
                        value={formData.count}
                        onChange={handleInputChange}
                        className="w-full border border-gray-300 rounded-md p-2 mb-4"
                        placeholder="تعداد را وارد کنید"
                        min="1"
                    />
                </div>

                <div className="col-span-2 flex flex-col gap-1">
                    <span>متن ارسال</span>
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        className="w-full border min-h-[200px] border-gray-300 rounded-md p-2 mb-4"
                        placeholder="متن پیام را وارد کنید"
                    />
                </div>

                <div className="col-span-2 flex justify-center gap-4 mt-4">
                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-6 rounded-md disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                    >
                        {loading ? "در حال ارسال..." : "ارسال پیام"}
                    </button>
                    <button
                        type="button"
                        onClick={() => setFormData({
                            senderNumber: "",
                            category: "",
                            platform: "",
                            count: "",
                            message: ""
                        })}
                        className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-6 rounded-md transition-colors"
                    >
                        پاک کردن فرم
                    </button>
                </div>
            </form>
        </div>
    );
}